// Converts name of filter in front-end
// to name used in body payload
export const FILTER_NAME_TO_KEY = {
    "Dorm":"DORM",
    "Columbia":"COLUMBIA",
    "Barnard":"BARNARD",
    "Single":"SINGLE_",
    "Double":"DOUBLE_",
    "Triple":"TRIPLE_",
    "Apartment Style":"APARTMENT_",
    "Suite Style":"SUITE_",
    "Corridor Style": "NOTSUITE_",
    "2 Person":"TWO_SUITE",
    "3 Person":"THREE_SUITE",
    "4 Person":"FOUR_SUITE",
    "5 Person":"FIVE_SUITE",
    "6 Person":"SIX_SUITE",
    "7 Person":"SEVEN_SUITE",
    "8 Person":"EIGHT_SUITE",
    "9 Person":"NINE_SUITE",
    "10 Person":"TEN_SUITE",
    "First Year":"FRESHMAN",
    "Sophomore":"SOPHOMORE",
    "Junior":"JUNIOR",
    "Senior":"SENIOR",
    "A/C":"AC",
    "Gym":"GYM",
    "Single-Use Bathroom":"P_BATHROOM",
    "Private Kitchen":"P_KITCHEN"
};